<script lang="ts">
	import { CardGrid, Input, SelectCard, Text } from '@Shelly/shelly-design-system';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { devices_config } from '@devices/index';
	import { deriveRoomName } from 'src/helpers/service_rooms_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { createMemberStatusSnapshot } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	import { includingDeviceData } from 'src/stores/features/inclusion';
	import type { Device } from 'src/types/Device';
	import { format } from 'svelte-i18n';
	import { real_id } from 'src/helpers/interface_helpers';

	export let inclusionData;

	let allCardsRefs: { [key: string | number]: HTMLElement } = {};

	const filterDevicesByRoomID: any = (array: Device[]) => {
		let filteredDevicesByRoom = {};

		array.forEach((device: Device, i) => {
			const roomID = device.room_id;

			const deviceData = {
				name: `${device.name}${
					typeof memberStatus[real_id(device.id)] === 'undefined'
						? `- ${capFirstChar($format('label_offline'))}`
						: ''
				}`,
				id: device.id,
				selected: false,
				roomName: deriveRoomName(roomID),
				roomID: roomID,
				image: device.image ? device.image : undefined,
				backgroundColor: device.backgroundColor ? device.backgroundColor : undefined,
				icon: device.icon ? device.icon : undefined,
			};

			if (filteredDevicesByRoom[roomID]) {
				filteredDevicesByRoom[roomID].cards = [
					...filteredDevicesByRoom[roomID].cards,
					deviceData,
				];
			} else {
				filteredDevicesByRoom[roomID] = {
					cards: [deviceData],
					roomName: deriveRoomName(roomID),
					roomID: roomID,
				};
			}
		});

		return Object.values(filteredDevicesByRoom);
	};
	$: gatewayDevices = Object.values($devices).filter(
		(d) => d.type === 'SNGW-ZW01' || d.type === 'S3GW-1DZW0EU',
	);
	$: gatewayIds = gatewayDevices.map((d) => d.id);
	$: memberStatusStore = createMemberStatusSnapshot(gatewayIds);
	$: memberStatus = $memberStatusStore;
	$: mappedListDevicesByRoomID = filterDevicesByRoomID(
		gatewayDevices.filter((d) => memberStatus[real_id(d.id)]?.online),
	);

	const onDeviceSelect = (e) => {
		const device = e.detail;
		const currentDeviceID = device.id;
		const currenDeviceRoomID = device.roomID;

		mappedListDevicesByRoomID = mappedListDevicesByRoomID.map((room: any) => {
			if (room.roomID === currenDeviceRoomID) {
				return {
					...room,
					cards: room.cards.map((d) => {
						if (d.id === currentDeviceID) {
							if (!d.selected) {
								inclusionData.selected = device;
							} else {
								inclusionData.selected = undefined;
							}
							return {
								...d,
								selected: !d.selected,
							};
						} else {
							return {
								...d,
								selected: false,
							};
						}
					}),
				};
			}

			return room;
		});
	};
</script>

<Text element="h2" class="mb-s">
	{$format('inclusion_wifi_device_type', {
		default: 'Device type',
	})}
</Text>
<Text class="mb-s" styleType="body-small">
	{$format('inclusion_via', {
		default: 'Select the device you want to include.',
	})}
</Text>

{#if mappedListDevicesByRoomID.length > 0}
	<SelectList
		title={''}
		list={mappedListDevicesByRoomID}
		bind:allCardsRefs
		withSearch={true}
		on:click={onDeviceSelect}
		selectedCardsId={[{ id: inclusionData?.selected?.id }]}
	/>
{:else}
	<Text
		>{$format('description_unavailable_z_wave_devices', {
			default: "You don't have any online Z-Wave gateways.",
		})}</Text
	>
{/if}
